import React from 'react'
import { IconMessage, IconPhone } from '@tabler/icons-react'

export default function CTASection() {
  const handleBookConsultant = () => {
    window.location.href = 'tel:400-XXX-XXXX'
  }

  const handleOnlineChat = () => {
    alert('在线咨询功能即将上线')
  }

  return (
    <section className="relative py-32 overflow-hidden bg-gradient-to-br from-orange-500 via-orange-600 to-orange-500">
      <div className="absolute inset-0 noise-texture"></div>

      <div className="absolute inset-0">
        <div className="absolute top-10 right-10 w-96 h-96 bg-white/10 rounded-full blur-3xl animate-[floatSlow_8s_ease-in-out_infinite]"></div>
        <div className="absolute bottom-10 left-10 w-80 h-80 bg-white/10 rounded-full blur-3xl animate-[floatSlow_10s_ease-in-out_infinite_reverse]"></div>
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-6 lg:px-12">
        <div className="text-center space-y-10">
          <div className="space-y-6">
            <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white leading-tight">
              在「用人、租赁、合作」之前
              <br />
              <span className="text-white/90">多看一眼风险</span>
              <br />
              <span className="text-3xl sm:text-4xl lg:text-5xl font-semibold text-white/80">会少走很多弯路</span>
            </h2>

            <p className="text-lg sm:text-xl text-white/90 max-w-3xl mx-auto leading-relaxed font-light">
              告诉我们你的行业和当前面临的风险困扰，优查查团队会为你提供一套简单可行的落地方案，让风控这件事真正变得「可执行」
            </p>
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <button
              onClick={handleBookConsultant}
              className="inline-flex items-center gap-3 px-10 py-5 bg-white text-orange-600 rounded-2xl font-bold text-lg shadow-2xl hover:shadow-xl hover:-translate-y-1 transition-all duration-300"
            >
              <IconPhone size={24} />
              预约顾问一对一讲解
            </button>
            <button
              onClick={handleOnlineChat}
              className="inline-flex items-center gap-3 px-10 py-5 bg-transparent text-white border-2 border-white rounded-2xl font-bold text-lg hover:bg-white/10 hover:-translate-y-1 transition-all duration-300"
            >
              <IconMessage size={24} />
              在线咨询
            </button>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-white/30 to-transparent"></div>
    </section>
  )
}
